export const CALENDLY_EVENTS_STAGING = [
  {
    id: 'premier-renouvellement',
    value: 'Premier renouvellement à 4 mois avec Dr Brument',
    label: 'Premier renouvellement à 4 mois avec Dr Brument',
  },
  {
    id: 'renouvellement-annuel',
    value: 'Renouvellement annuel avec Dr Brument',
    label: 'Renouvellement annuel avec Dr Brument',
  },
  {
    id: 'sleepdoctor-teleconsultation',
    value: 'SleepDoctor téléconsultation',
    label: 'SleepDoctor téléconsultation',
  },
  {
    id: 'sleepdoctor-teleconsultation-suivi',
    value: 'SleepDoctor téléconsultation de suivi avec Dr Brument',
    label: 'SleepDoctor téléconsultation de suivi avec Dr Brument',
  },
  {
    id: 'teleconsultation-doctor',
    value: 'Téléconsultation_doctor',
    label: 'Téléconsultation doctor',
  },
  {
    id: 'teleconsultation-1',
    value: 'Téléconsultation_1',
    label: 'Téléconsultation 1',
  },
  {
    id: 'teleconsultation-2',
    value: 'Téléconsultation_2',
    label: 'Téléconsultation 2',
  },
  {
    id: 'teleconsultation-avec-brument',
    value: 'Téléconsultation avec Dr Brument',
    label: 'Téléconsultation avec Dr Brument',
  },
  {
    id: 'teleconsultation-suivi',
    value: 'Téléconsultation de suivi avec Dr Brument',
    label: 'Téléconsultation de suivi avec Dr Brument',
  },
];

export const CALENNDLY_EVENTS_PROD = [
  {
    id: 'ppc-consultation',
    value: 'PPC consultation',
    label: 'PPC consultation',
  },
  {
    id: 'premier-renouvellement-camus',
    value: 'Premier renouvellement à 4 mois avec Dr Camus',
    label: 'Premier renouvellement à 4 mois avec Dr Camus',
  },
  {
    id: 'premier-renouvellement-castera',
    value: 'Premier renouvellement à 4 mois avec Dr Castera',
    label: 'Premier renouvellement à 4 mois avec Dr Castera',
  },
  {
    id: 'premier-renouvellement-dallaire',
    value: 'Premier renouvellement à 4 mois avec Dr Dallaire',
    label: 'Premier renouvellement à 4 mois avec Dr Dallaire',
  },
  {
    id: 'premier-renouvellement-escourrou',
    value: 'Premier renouvellement à 4 mois avec Dr Escourrou',
    label: 'Premier renouvellement à 4 mois avec Dr Escourrou',
  },
  {
    id: 'premier-renouvellement-felix',
    value: 'Premier renouvellement à 4 mois avec Dr Felix',
    label: 'Premier renouvellement à 4 mois avec Dr Felix',
  },
  {
    id: 'premier-renouvellement-harrouchi',
    value: 'Premier renouvellement à 4 mois avec Dr Harrouchi',
    label: 'Premier renouvellement à 4 mois avec Dr Harrouchi',
  },
  {
    id: 'premier-renouvellement-lepine',
    value: 'Premier renouvellement à 4 mois avec Dr Jeremy Lepine',
    label: 'Premier renouvellement à 4 mois avec Dr Jeremy Lepine',
  },
  {
    id: 'premier-renouvellement-lucie',
    value: 'Premier renouvellement à 4 mois avec Dr Lucie Bouffard',
    label: 'Premier renouvellement à 4 mois avec Dr Lucie Bouffard',
  },
  {
    id: 'premier-renouvellement-margaine',
    value: 'Premier renouvellement à 4 mois avec Dr Margaine',
    label: 'Premier renouvellement à 4 mois avec Dr Margaine',
  },
  {
    id: 'premier-renouvellement-saab',
    value: 'Premier renouvellement à 4 mois avec Dr Saab',
    label: 'Premier renouvellement à 4 mois avec Dr Saab',
  },
  {
    id: 'premier-renouvellement-taieb',
    value: 'Premier renouvellement à 4 mois avec Dr Taieb',
    label: 'Premier renouvellement à 4 mois avec Dr Taieb',
  },
  {
    id: 'renouvellement-camus',
    value: 'Renouvellement annuel avec Dr Camus',
    label: 'Renouvellement annuel avec Dr Camus',
  },
  {
    id: 'renouvellement-castera',
    value: 'Renouvellement annuel avec Dr Castera',
    label: 'Renouvellement annuel avec Dr Castera',
  },
  {
    id: 'renouvellement-dallaire',
    value: 'Renouvellement annuel avec Dr Dallaire',
    label: 'Renouvellement annuel avec Dr Dallaire',
  },
  {
    id: 'renouvellement-escourrou',
    value: 'Renouvellement annuel avec Dr Escourrou',
    label: 'Renouvellement annuel avec Dr Escourrou',
  },
  {
    id: 'renouvellement-felix',
    value: 'Renouvellement annuel avec Dr Felix',
    label: 'Renouvellement annuel avec Dr Felix',
  },
  {
    id: 'renouvellement-harrouchi',
    value: 'Renouvellement annuel avec Dr Harrouchi',
    label: 'Renouvellement annuel avec Dr Harrouchi',
  },
  {
    id: 'renouvellement-lepine',
    value: 'Renouvellement annuel avec Dr Jeremy Lepine',
    label: 'Renouvellement annuel avec Dr Jeremy Lepine',
  },
  {
    id: 'renouvellement-lucie',
    value: 'Renouvellement annuel avec Dr Lucie Bouffard',
    label: 'Renouvellement annuel avec Dr Lucie Bouffard',
  },
];

export const REMINDER_DATE_OPTIONS = [
  {
    id: '1-month',
    value: 1,
    label: '1 month',
    default: true,
  },
  {
    id: '2-months',
    value: 2,
    label: '2 months',
  },
  {
    id: '3-months',
    value: 3,
    label: '3 months',
  },
  {
    id: '4-months',
    value: 4,
    label: '4 months',
  },
  {
    id: '5-months',
    value: 5,
    label: '5 months',
  },
  {
    id: '6-months',
    value: 6,
    label: '6 months',
  },
  {
    id: '7-months',
    value: 7,
    label: '7 months',
  },
  {
    id: '8-months',
    value: 8,
    label: '8 months',
  },
  {
    id: '9-months',
    value: 9,
    label: '9 months',
  },
  {
    id: '10-months',
    value: 10,
    label: '10 months',
  },
  {
    id: '11-months',
    value: 11,
    label: '11 months',
  },
  {
    id: '12-months',
    value: 12,
    label: '12 months',
  },
  {
    id: '18-months',
    value: 18,
    label: '18 months',
  },
  {
    id: '24-months',
    value: 24,
    label: '24 months',
  },
  {
    id: '36-months',
    value: 36,
    label: '36 months',
  },
  {
    id: '48-months',
    value: 48,
    label: '48 months',
  },
];
